import { render, staticRenderFns } from "./UcbFooterInvestment.vue?vue&type=template&id=eb2bea64&scoped=true"
import script from "./UcbFooterInvestment.vue?vue&type=script&lang=ts"
export * from "./UcbFooterInvestment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2bea64",
  null
  
)

export default component.exports